/**
 * allKeys.js
 * Written by: Alex Kasemir
 */
import uniq from 'lodash/uniq';
import badgeActions from '../../actions';

/**
 * Description of the allKeys reducer
 */
const allKeys = (state = [], action) => {
  switch (action.type) {
    case badgeActions.GET_BADGES_SUCCESS:
      return uniq(state.concat(action.data.map((i) => i.slug)));
    case badgeActions.GET_BADGE_SUCCESS:
      return uniq(state.concat([action.badge.slug]));
    default:
      return state;
  }
};

export default allKeys;
